import React, { useState } from 'react';
import FadeInSection from "./FadeInSection"; // Import animation wrapper
import "./ExploreModleeAgent.css"; // Import the CSS file

// import Moderation from './Moderation';
// import Project2 from './Project2';
import Demos from "./Demos";


const ExploreModleeAgent = () => {

    const handleScrollToSection = (id) => {
        const section = document.getElementById(id);
        if (section) {
            section.scrollIntoView({ behavior: "smooth" });
        }
    };    

    // const [activeProject, setActiveProject] = useState('Moderation');


  return (
    <>
    <FadeInSection className="explore-agent-container">
      {/* Title Section */}
      <h2 className="explore-agent-title">Accelerate with Modlee</h2>
      <p className="explore-agent-subtitle">
       We create essential <strong>foundational AI agents</strong> that empower every business. Combined with our self-improving AI technology, they form a robust infrastructure that drives efficiency and growth from day one.
      </p>

      {/* Two-Column Grid */}
      <div className="explore-agent-grid">
        {/* Column 1 - Testing */}
        <div className="explore-column">
          <h3 className="explore-column-title">See for Yourself</h3>
          <p className="explore-agent-text">
          <strong>Explore our agents</strong> for free to see how they'd fit into your workflows.
          </p>
          <p
            className="explore-agent-link"
            onClick={() => handleScrollToSection("demos")}
          >
            → Select a demo
          </p>
        </div>

        {/* Column 2 - API Integration */}
        <div className="explore-column">
          <h3 className="explore-column-title">Integrate our API</h3>
          <p className="explore-agent-text">
            Use our <strong>Foundational AI Agent API</strong> to effortlessly integrate our foundational agents.
          </p>
          <p
            className="explore-agent-link"
            onClick={() => handleScrollToSection("get-started")}
          >
            → Get started today
          </p>
        </div>
      </div>

    </FadeInSection>
    <Demos />
    </>

  );
};

export default ExploreModleeAgent;
